/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Badge, Tooltip } from '@mui/material';
import React, { useContext } from 'react';

import { Colors } from 'src/common/ui/base';
import { CircleButton } from 'src/common/ui/components';
import RouterLink from 'src/components/general/routerLink';
import { DoseSpotNotificationsContext } from 'src/prescribing/doseSpot/components/DoseSpotNotificationsContext';
import { DoseSpotNotificationsProvider } from 'src/prescribing/doseSpot/components/DoseSpotNotificationsProvider';

const NotificationsIcon = () => {
  const { count } = useContext(DoseSpotNotificationsContext);

  return (
    <RouterLink routeName="erx">
      <Tooltip
        title="DoseSpot"
        css={css`
          color: ${Colors.White};

          .MuiBadge-standard {
            background-color: ${Colors.Coral2};
          }
        `}
      >
        <Badge badgeContent={count}>
          {/** Tooltip / Badge requires a ref-able component as a child */}
          <span>
            <CircleButton
              data-testid="dose-spot-notifications-icon"
              icon="localPharmacy"
              color="transparent-inverted"
            />
          </span>
        </Badge>
      </Tooltip>
    </RouterLink>
  );
};

export const DoseSpotNotificationsIcon = () => (
  <DoseSpotNotificationsProvider>
    <NotificationsIcon />
  </DoseSpotNotificationsProvider>
);
